<template>
  <GenericDialog :activator="!!location" @close="emit('close')">
    <FavLocationForm
      v-if="location"
      :initial-value="location"
      @close="emit('close')"
    />
  </GenericDialog>
</template>

<script setup lang="ts">
import GenericDialog from "@/components/dialog-wrappers/GenericDialog.vue";
import type SavedLocation from "@/domains/locations/savedLocation.ts";
import FavLocationForm from "./FavLocationForm.vue";

/**
 * Edit-a-saved-location dialog, opened directly from a location's list card
 * (LocationDisplayCard.vue via LocationsPage.vue) rather than requiring a
 * detour through LocationDetails.vue's own inline edit toggle.
 *
 * `location` doubles as the dialog's open/closed state - non-null opens it
 * pre-filled with that location, null closes it - so the caller doesn't
 * need a separate boolean in sync with which location is being edited.
 */
const { location } = defineProps<{
  location: SavedLocation | null;
}>();

const emit = defineEmits<{ (e: "close"): void }>();
</script>
